import { Component, model, input, inject } from '@angular/core';
import { DialogModule } from '@openng/optimus-ui/dialog';
import { ListboxModule } from '@openng/optimus-ui/listbox';
import { ListboxClickEvent } from '@openng/optimus-ui/types/listbox';
import { FileUploadServiceV2 } from '../../services/file-upload-v2.service';

export interface DsmPaymentImage {
  id: string;
  s3Key: string;
  directUrl: string;
}

@Component({
  selector: 'lib-link-list-dialog',
  imports: [DialogModule, ListboxModule],
  templateUrl: './link-list-dialog.html',
  styleUrl: './link-list-dialog.scss',
  standalone: true
})
export class LinkListDialog {
  #fileUploadService = inject(FileUploadServiceV2);

  visible = model(false);
  items = input.required<DsmPaymentImage[]>();
  header = input<string>('');
  emptyMessage = input<string>('No items available');

  onItemClick(event: ListboxClickEvent): void {
    const item = event.option as DsmPaymentImage;
    this.#fileUploadService.getPresignedUrlFromS3DocumentId(item.id).subscribe(url => {
      window.open(url, '_blank');
    });
  }
}
